import { $isListItemNode } from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_CRITICAL,
  KEY_TAB_COMMAND,
} from 'lexical';
import { useEffect } from 'react';

const NestedListPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        KEY_TAB_COMMAND,
        args => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) {
            return false;
          }

          const anchorNode = selection.anchor.getNode();
          const anchorIsListItem = $isListItemNode(anchorNode);

          if (anchorIsListItem) {
            if (args.shiftKey) {
              anchorNode.setIndent(anchorNode.getIndent() - 1);
            } else {
              anchorNode.setIndent(anchorNode.getIndent() + 1);
            }
            args.preventDefault();
            return true;
          }

          const parent = anchorNode.getParent();
          if (parent) {
            const parentIsListItem = $isListItemNode(parent);
            if (parentIsListItem) {
              if (args.shiftKey) {
                parent.setIndent(parent.getIndent() - 1);
              } else {
                parent.setIndent(parent.getIndent() + 1);
              }
              args.preventDefault();
              return true;
            }
          }

          return false;
        },
        COMMAND_PRIORITY_CRITICAL,
      ),
    );
  }, [editor]);

  return null;
};

export { NestedListPlugin };
